<div class="container-fluid">

    <div class="row gutter-xl">

        <div class="col-auto">
            <i class="fa-solid fa-square-exclamation error-icon"></i>
        </div>

        <div class="col-md col-sm-12">

            <h1>{{'store.errors.list_model_error_heading' | translate}}</h1>
            <p>{{'store.errors.list_model_error_description' | translate}}</p>

            <div class="row gutter-xs">
                <div class="col-auto" *ngIf="previousLocation">
                    <a [routerLink]="[previousLocation]" class="btn btn-primary">
                        {{'store.errors.reload_page' | translate}}
                    </a>
                </div>

                <div class="col-auto">
                    <a [routerLink]="['/']" class="btn"
                        [ngClass]="previousLocation ? 'btn-outline-primary' : 'btn-primary'">
                        {{'store.errors.to_frontpage' | translate}}
                    </a>
                </div>
            </div>

        </div>
    </div>
</div>